import React from 'react';
import { Button } from 'reactstrap';
import {
  DeleteModal, Header, Footer, Body,
} from './styles';

export const DeleteLocalModal = ({ modalIsOpen, toggle, confirmDelete }) => (
  <DeleteModal isOpen={modalIsOpen} toggle={toggle} className="modal-delete-local">
    <Header toggle={toggle}>Deletar Local</Header>
    <Body>
      <p>
        Tem certeza que deseja excluir este local?
        <br />
        Você pode editá-lo ou adicioná-lo novamente depois.
      </p>
    </Body>
    <Footer>
      <Button onClick={confirmDelete}>Deletar local</Button>
    </Footer>
  </DeleteModal>
);

export const UnauthorizedLocalModal = ({ modalIsOpen, toggle }) => (
  <DeleteModal isOpen={modalIsOpen} toggle={toggle} className="modal-delete-local">
    <Header toggle={toggle}>Ação não autorizada</Header>
    <Body>
      <p>
        Esta empresa possui integração de endereços.
        <br />
        <br />
        Você pode salvar a informação no sistema de sua empresa e o endereço será atualizado automaticamente em nossa base.
      </p>
    </Body>
    <Footer>
      <Button onClick={toggle}>Fechar</Button>
    </Footer>
  </DeleteModal>
);
